// ===============================================================================
// JoinGroup.js - Join Group via Invite Code for WOW
// ===============================================================================
// Location: /var/www/wow/frontend/src/JoinGroup.js
// Form to join a group using invite code
// ===============================================================================

import React, { useState } from "react";
import { groupsAPI } from "./api";
import "./JoinGroup.css";

function JoinGroup({ onBack, onGroupJoined }) {
  // ===============================================================================
  // State
  // ===============================================================================
  const [inviteCode, setInviteCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ===============================================================================
  // Submit Handler
  // ===============================================================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!inviteCode.trim()) {
      setError("Invite code is required");
      return;
    }
    
    setLoading(true);
    setError("");
    
    try {
      const res = await groupsAPI.join(inviteCode.trim().toUpperCase());
      if (res.data?.ok) {
        console.log("✅ Joined group:", res.data.group);
        onGroupJoined(res.data.group);
      } else {
        setError("Failed to join group");
      }
    } catch (err) {
      console.error("Join group error:", err);
      setError(err?.response?.data?.detail || "Invalid invite code");
    }
    
    setLoading(false);
  };

  // ===============================================================================
  // Render
  // ===============================================================================
  return (
    <div className="join-group-page">

      <div className="join-group-card">
        <div className="card-icon">🔗</div>
        <h2>Enter Invite Code</h2>
        <p>Ask your friend for the group's invite code and enter it below</p>

        <form onSubmit={handleSubmit} className="join-form">
          <div className="form-group">
            <label htmlFor="inviteCode">Invite Code</label>
            <input
              id="inviteCode"
              type="text"
              value={inviteCode}
              onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
              placeholder="e.g., ABC12XYZ"
              disabled={loading}
              maxLength={20}
              className="invite-code-input"
              required
            />
          </div>

          {error && <div className="form-error">{error}</div>}

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? "Joining..." : "Join Group"}
          </button>
        </form>

        <div className="join-help">
          <h3>How to get an invite code?</h3>
          <ol>
            <li>Ask a group member to open the group</li>
            <li>They can find the invite code in group settings</li>
            <li>The code looks like: <strong>ABC12XYZ</strong></li>
          </ol>
        </div>
      </div>
    </div>
  );
}

export default JoinGroup;

